import { Injectable } from '@angular/core';
import { HttpRequest } from '@angular/common/http';
import { environment } from '@root/src/environments/environment';
import { MOBILE_APP_WEB_HEADERS } from '@shared/data/mobile-app-headers';

/**
 * Owns web client identity headers for monolith `/api` calls.
 * HTTP still goes through generated clients; this only clones requests.
 */
@Injectable({ providedIn: 'root' })
export class MobileAppHeadersService {
  headers(): Record<string, string> {
    return { ...MOBILE_APP_WEB_HEADERS };
  }

  appliesTo(url: string): boolean {
    if (!url || url.includes('/assets/')) {
      return false;
    }

    const apiBase = (environment.api || '').replace(/\/+$/, '');
    if (apiBase && (url === apiBase || url.startsWith(`${apiBase}/`) || url.startsWith(`${apiBase}?`))) {
      return true;
    }

    return url === '/api' || url.startsWith('/api/') || url.startsWith('/api?');
  }

  applyTo<T>(req: HttpRequest<T>): HttpRequest<T> {
    if (!this.appliesTo(req.url)) {
      return req;
    }

    return req.clone({ setHeaders: this.headers() });
  }
}
